import React, { useState, useEffect, useCallback } from 'react';
import { Box } from '@mui/material';

const CapsLockOverlay: React.FC = () => {
    const [capsLockOn, setCapsLockOn] = useState<boolean | null>(null);

    // Проверка CapsLock при первом взаимодействии с клавиатурой
    const handleKeyEvent = useCallback((e: KeyboardEvent) => {
        setCapsLockOn(e.getModifierState('CapsLock'));
    }, []);

    // Проверка CapsLock при клике мыши (для определения состояния при входе)
    const handleMouseEvent = useCallback((e: MouseEvent) => {
        // MouseEvent также поддерживает getModifierState
        setCapsLockOn(e.getModifierState('CapsLock'));
    }, []);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyEvent);
        window.addEventListener('keyup', handleKeyEvent);
        window.addEventListener('mousedown', handleMouseEvent);

        return () => {
            window.removeEventListener('keydown', handleKeyEvent);
            window.removeEventListener('keyup', handleKeyEvent);
            window.removeEventListener('mousedown', handleMouseEvent);
        };
    }, [handleKeyEvent, handleMouseEvent]);

    // Не показываем overlay пока не определили состояние CapsLock
    if (!capsLockOn) {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
            }}
        >
            <Box
                sx={{
                    fontSize: '3rem',
                    fontWeight: 'bold',
                    color: '#ff3333',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    textShadow: '0 0 20px rgba(255, 51, 51, 0.5)',
                }}
            >
                Включен CapsLock
            </Box>
            <Box
                sx={{
                    fontSize: '1.2rem',
                    color: '#ffffff',
                    textAlign: 'center',
                    opacity: 0.9,
                }}
            >
                Продолжение невозможно пока нажата клавиша CapsLock
            </Box>
        </Box>
    );
};

export default CapsLockOverlay;
